import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router, Scroll, RouterLink, RouterLinkActive } from '@angular/router';
import { NgClass } from '@angular/common';

import { filter } from 'rxjs';

@Component({
  selector: 'app-landing',
  templateUrl: './sandoz-classes-espanol.html',
  styleUrls: ['./sandoz-classes-espanol.css'],
  imports: [RouterLink, RouterLinkActive, NgClass],

})
export class SandozEspanol implements OnInit {

  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller
  ) { }

  ngOnInit() {
    this.router.events.pipe(
      filter((e: any): e is Scroll => e instanceof Scroll)
    ).subscribe(e => {
      if (e.position) {
        this.viewportScroller.scrollToPosition(e.position);
      } else if (e.anchor) {
        this.viewportScroller.scrollToAnchor(e.anchor);
      } else {
        this.viewportScroller.scrollToPosition([0, 0]);
      }
    });
  }

}
